import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import {toast} from "react-toastify";
import UsersAPI from "../../../apis/adminApi/userAPI";
import Pagination from "../../assets/Pagination";
import TableLoader from "../../loaders/TableLoader";

const StationIndex = () => {
    const [stations, setStations] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);

    //Permet d'aller recuperer les invoices
    const fetchStations = async () => {
        try{
            const data =  await UsersAPI.findAllStations();
            setStations(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des gestionnaires de station !");
        }
    };

    useEffect(() => {
        fetchStations();
    },[]);



    //Gestion du changement de page
    const handleChangeCurrentPage = page => {
        setCurrentPage(page);
    };

    //Gestion de la recherche
    const handleSearch = ({currentTarget}) => {
        setSearch(currentTarget.value);
        setCurrentPage(1);
    };

    const itemsPerPage = 100;

    //Filtrage des buses en fonction de la recherche

    const filteredStations = stations.filter(
        c =>
            c.name.toLowerCase().includes(search.toLowerCase()) ||
            c.email.toLowerCase().includes(search.toLowerCase()) ||
            c.phone.toLowerCase().includes(search.toLowerCase()) ||
            c.city.toLowerCase().includes(search.toLowerCase())
    );

    //Pagination des données
    const paginatedStations = Pagination.getData(
        filteredStations,
        currentPage,
        itemsPerPage
    );



    let count = 1;


    return (
        <>
            <div className="pagetitle">
                <h1>Les gestionnaires de station</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/admin">Dashboard</Link></li>
                        <li className="breadcrumb-item active">Les gestionnaires de station KKS</li>
                    </ol>
                </nav>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-6">
                                        <h5 className="card-title">Total {stations ? stations.length : 0}</h5>
                                    </div>
                                    <div className="col-6">
                                        <Link className="btn btn-sm btn-primary mt-3" to="/admin/users/add">
                                            <i className="bi bi-plus-circle"></i> Ajouter un gestionnaire de station
                                        </Link>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-3">
                                        <div className="form-group">
                                            <input type="text" onChange={handleSearch} value={search} autoComplete="off" className="form-control" placeholder="Rechercher ..." />
                                        </div>
                                    </div>
                                </div>
                                <table className="table table-hover">
                                    <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Nom</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">Telephone</th>
                                        <th scope="col">Ville de residence</th>
                                        <th scope="col">Station</th>
                                        <th scope="col">Actif</th>
                                        <th scope="col">Options</th>
                                    </tr>
                                    </thead>
                                    {!loading && <tbody>
                                    {paginatedStations.map((station) => (
                                        <tr key={station.id}>
                                            <th scope="row">{count++}</th>
                                            <td>{station.name}</td>
                                            <td>{station.email}</td>
                                            <td>{station.phone}</td>
                                            <td>{station.city}</td>
                                            <td>{station.station_name} / {station.station_city}</td>
                                            <td>
                                                {station.actived === 0 ?
                                                    (<><i className="text-danger bi bi-x-circle-fill"></i></>) :
                                                    (<><i className="text-success bi bi-check-square-fill"></i></>)
                                                }
                                            </td>

                                            <td>
                                                <div className="btn-group badge" role="group" aria-label="Basic example">
                                                    <Link className="btn btn-sm btn-success" to={`/admin/users/edit/${station.id}`}>
                                                        editer
                                                    </Link>
                                                    <Link className="btn btn-sm btn-outline-primary" to={`/admin/users/affecteToStations/${station.id}`}>
                                                        Affectation
                                                    </Link>
                                                    <Link className="btn btn-sm btn-outline-danger" to={`/admin/users/updateUserPassword/${station.id}`}>
                                                        Mot de passe
                                                    </Link>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                    }

                                    </tbody> }
                                </table>

                                {loading && <TableLoader width={500} height={550} />}

                                {itemsPerPage < filteredStations.length &&
                                    <Pagination
                                        currentPage={currentPage}
                                        itemsPerPage={itemsPerPage}
                                        length={filteredStations.length}
                                        onPageChange={handleChangeCurrentPage}
                                    />
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default StationIndex;
